<template>
  <button
    type="button"
    :class="{
      open: isMenuOpen,
      selected: isCustomRangeApplied,
    }"
    class="d-flex align-center justify-start dp__input_wrap date-trigger"
  >
    <DpplSvg
      file-name="icon-calendar"
      class="mr-1"
    />
    <div class="date-picker-input text-body-3">
      Custom
    </div>
  </button>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineProps({
  isMenuOpen: {
    type: Boolean,
    required: true,
  },
  isCustomRangeApplied: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="less">
.dp__input_wrap {
  cursor: pointer;
  background: @white;
  width: auto;
  max-width: 245px;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;

  .date-picker-input {
    color: @text-dark;
    border: none;
    outline: none;
    cursor: pointer;
  }

  &.open, &.selected {
    background-color: @bg-brand-light;

    .date-picker-input {
      color: @text-brand;
    }

    path {
      fill: @icon-brand;
    }

    i {
      color: @text-brand;
    }
  }
}

.date-trigger {
  padding: 6px 16px;
  height: 28px;

  &:hover {
    background: @bg-brand-light;

    .date-picker-input {
      color: @primary;
    }

    path {
      fill: @primary;
    }
  }

  &:focus {
    outline: revert;
  }
}
</style>
